import { useParams } from "react-router-dom";
import { getAllModulosByIdIdioma } from "../../../services/modulo.service";
import { useEffect, useState } from "react";
import { ContenedorPageTemplate } from "../../../components/templates/ContenedorPageTemplate";
import { paginacion } from "../../../utils/paginacion/paginacion";
import { DataTable } from "../../../components/organisms/DataTable";
import { TITULO_IDIOMA_DETALLE } from "../../../utils/constantes";
import { getOneIdioma } from "../../../services/idioma.service";

export const IdiomaDetalle = () => {
  const { idIdioma } = useParams();
  const [idioma, setIdioma] = useState(null);
  const [modulos, setModulos] = useState(null);
  const [paginaActual, setPaginaActual] = useState(1);
  const [busqueda, setBusqueda] = useState("");
  const modulosPorPagina = 8;
  const columnas = ["#", "Nombre", "Sigla"];
  const modulosFiltrados = modulos?.filter((modulo) => {
    const texto = busqueda.toLowerCase();
    const nombre = modulo?.nombre?.toLowerCase() || "";
    const sigla = modulo?.sigla?.toLowerCase() || "";
    return nombre.includes(texto) || sigla.includes(texto);
  }) || [];

  const {
    objetosEnPagina: modulosEnPagina,
    paginas,
    paginaInicial,
    paginaFinal,
  } = paginacion(paginaActual, modulosFiltrados, modulosPorPagina);


  useEffect(() => {
    getAllModulosByIdioma(idIdioma);
    getOneIdiomaHandler(idIdioma);
  }, []);

  const getAllModulosByIdioma = async (idIdioma) => {
    await getAllModulosByIdIdioma(idIdioma)
      .then((modulos) => setModulos(modulos))
      .catch((err) => console.log(err));
  };
  const getOneIdiomaHandler = async (idIdioma) => {
    await getOneIdioma(idIdioma)
      .then((idioma) => setIdioma(idioma))
      .catch((err) => console.log(err));
  };

  return (
    <ContenedorPageTemplate objetos={modulos} titulo={TITULO_IDIOMA_DETALLE}>
      {modulos?.length === 0 ? (
        <div className="text-center text-2xl text-black bg-white py-4 rounded-lg">
          <span>{`En estos momentos no hay módulos registrados para el idioma: ${idioma?.nombre}`}</span>
        </div>
      ) : (
        <>
          <div className="flex gap-4 py-3">
            <input
              type="text"
              placeholder="Buscar por nombre o sigla"
              value={busqueda}
              onChange={(e) => {
                setBusqueda(e.target.value);
                setPaginaActual(1);
              }}
              className="flex-1 text-black border shadow-sm rounded-xl py-3 px-4 focus:ring-1 focus:border-blue-500 focus:ring-blue-300 transition-colors hover:border-blue-500 border-slate-200"
            />
          </div>
  
          <DataTable
            columnas={columnas}
            paginas={paginas}
            paginaInicial={paginaInicial}
            paginaFinal={paginaFinal}
            paginaActual={paginaActual}
            setPaginaActual={setPaginaActual}
          >
            {modulosEnPagina?.map((modulo, index) => (
              <tr key={index} className="bg-white [&>td]:p-3 [&>td]:text-gray-700">
                <td className="font-medium border-r border-slate-200 border-t">
                  {(paginaActual - 1) * modulosPorPagina + index + 1}
                </td>
                <td className="font-medium border-r border-slate-200 border-t">
                  {modulo?.nombre}
                </td>
                <td className="border-slate-200 border-t">{modulo?.sigla}</td>
              </tr>
            ))}
          </DataTable>
        </>
      )}
    </ContenedorPageTemplate>
  );
  
};
